import { Box, IconButton, Tooltip } from '@mui/material'

import { Icon as Iconify } from '@iconify/react'
import useInnovaTheme from 'components/common/hooks/useInnovaTheme'
import { useMemo } from 'react'

const BUTTON_SIZE = 28

const SelectionCarousel = ({ options = [] }) => {
  const { getTextColor } = useInnovaTheme()

  let textColor = useMemo(() => getTextColor(), [getTextColor])

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          maxWidth: '100%',
          overflowX: 'auto',
          overflowY: 'hidden',
          gap: 1,
          py: 1,

          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}>
        {options.map((option) => {
          return (
            <Tooltip key={option.key} title={option.toolTip} arrow>
              <IconButton
                size='small'
                onClick={(e) => {
                  option?.onClick?.(option.key)
                }}
                sx={{
                  width: BUTTON_SIZE,
                  height: BUTTON_SIZE,
                  flexShrink: 0,

                  borderRadius: 1.5,
                  border: '1px solid',
                  borderColor: 'divider',
                }}>
                <Iconify icon={option.icon} width={18} color={textColor} />
              </IconButton>
            </Tooltip>
          )
        })}
      </Box>
    </>
  )
}

export default SelectionCarousel
